import { Action, createReducer, on } from '@ngrx/store';
import { GlobalSettingsActions } from './global-settings.actions';

export const STORE_FEATURE_KEY_GLOBAL = 'global';

export interface GlobalSettingsState {
    loadingIndicator: boolean;
    statusToSatellite: boolean;
    statusFromSatellite: boolean;
    strategyId: number;
    revertChanges: boolean;
    clientModuleType?: string;
}

export const initializeGlobalSettingsState: GlobalSettingsState = {
    loadingIndicator: false,
    statusToSatellite: false,
    statusFromSatellite: false,
    strategyId: 0,
    revertChanges: false
};

const reducer = createReducer(
    initializeGlobalSettingsState,
    on(GlobalSettingsActions.saveAccountStrategySuccess, (state, payload) =>
        ({ ...state,
           loadingIndicator: true,
           revertChanges: false
        })),
    on(GlobalSettingsActions.getAccountSettingsLoggedInUserSuccess, (state, {
        statusFromSatellite, statusToSatellite, strategyId, clientModuleType}) =>
        ({ ...state,
           loadingIndicator: true,
           statusToSatellite,
           statusFromSatellite,
           strategyId,
           clientModuleType,
           revertChanges: false
        })),
    on(GlobalSettingsActions.saveAccountStrategySuccess, (state, {
        strategyId}) =>
        ({ ...state,
           loadingIndicator: true,
           strategyId,
           revertChanges: false
        })),
    on(GlobalSettingsActions.openConfirmDialogCancel, (state, payload) =>
        ({ ...state,
           loadingIndicator: true,
           revertChanges: true
        })),
    on(GlobalSettingsActions.saveAccountStrategy, (state, payload) =>
        ({ ...state,
           loadingIndicator: false,
           revertChanges: false
        }))
);

// tslint:disable-next-line:typedef only-arrow-functions
export function GlobalSettingsReducer(state: GlobalSettingsState | undefined, action: Action) {
    return reducer(state, action);
}
